export const mockData = {
    pages: [
        // Tableau de bord & Statistiques
        { name: "Tableau de bord", url: "/#", icon: "bx-home" },
        { name: "États Production", url: "/etats/production-globale", icon: "bx-bar-chart-alt" },
        { name: "États Sinistres", url: "/etats/sinistres", icon: "bx-bar-chart" },

        // Consultation
        { name: "Consultation Assurés", url: "/assures", icon: "bx-book" },

        // Production
        { name: "Nouveau contrat", url: "/ajouter-contrat-new", icon: "bx-file-plus" },
        { name: "Tous les contrats", url: "/production", icon: "bx-folder-open" },
        { name: "Propositions en cours", url: "/propositions", icon: "bx-transfer-alt" },
        { name: "Contrats en cours", url: "/contrats", icon: "bx-folder" },
        { name: "Contrats imprimés", url: "/contrats-imprimes", icon: "bx-printer" },
        { name: "Contrats non-imprimés", url: "/contrats-non-imprimes", icon: "bx-file-blank" },

        // Attestations
        { name: "Toutes les attestations", url: "/gestion-des-attestations", icon: "bx-list-check" },
        { name: "Commandes d’attestations", url: "/compagnies-commandes", icon: "bx-cart" },

        // Apporteurs
        { name: "Intermédiaires", url: "/intermediaires", icon: "bx-user-voice" },
        { name: "Courtiers", url: "/courtiers", icon: "bx-user-pin" },
        { name: "Commissions générées", url: "/commissions-generees", icon: "bx-dollar" },
        { name: "Bordereaux", url: "/bordereaux", icon: "bx-file" },

        // Opérations
        { name: "Cession", url: "/cession", icon: "bx-calculator" },
        { name: "Rétrocession", url: "/retrocessions", icon: "bx-refresh" },

        // Caisse
        { name: "Encaissements en cours", url: "/en-attente-d-encaissement", icon: "bx-time" },
        { name: "Encaissements", url: "/encaissements", icon: "bx-wallet" },
        { name: "Encaissement Mobile", url: "/transactions-mobile-money", icon: "bx-mobile-alt" },
        { name: "Reversement de primes", url: "/versements-en-compagnie", icon: "bx-export" },
        { name: "Bordereaux de versement", url: "/borderaux-de-versement-en-compagnie", icon: "bx-file-export" },

        // Comptabilité
        { name: "Comptes", url: "/comptabilite/comptes", icon: "bx-credit-card" },
        { name: "Ecritures comptables", url: "/comptabilite/grand-livre", icon: "bx-book-content" },
        { name: "Balance", url: "/comptabilite/balance", icon: "bx-balance" },
        { name: "Paramétrage Comptable", url: "/comptabilite/parametrage", icon: "bx-cog" },

        // Sinistres
        { name: "Déclaration de sinistres", url: "/declarer-sinister", icon: "bx-edit" },
        { name: "Liste des sinistres", url: "/liste-des-sinistres", icon: "bx-list-ul" },
        { name: "Évaluations sinistres", url: "/validation-evaluation", icon: "bx-check-circle" },
        { name: "Paiements sinistres", url: "/validation-decaissement", icon: "bx-money" },

        // Paramètres
        { name: "Organismes", url: "/membres", icon: "bx-group" },
        { name: "Tarification", url: "/tarification", icon: "bx-slider" },
        { name: "Paramètres sinistres", url: "/parametres/sinistres", icon: "bx-cog" },
        { name: "Autres paramètres", url: "/autres-parametres", icon: "bx-wrench" },

        // Droits & Accès
        { name: "Utilisateurs", url: "/utilisateurs", icon: "bx-user" },
        { name: "Profils", url: "/profils", icon: "bx-id-card" },
        { name: "Habilitations", url: "/habilitations", icon: "bx-lock" },
        { name: "Modules", url: "/modules", icon: "bx-package" },
        { name: "Routes", url: "/routes", icon: "bx-network-chart" },

        // Liens externes
        { name: "Support", url: "https://ossanasur.com/support", icon: "bx-support" },
        { name: "Documentation", url: "https://ossanasur.com/poolins/documentation/", icon: "bx-book-alt" },
    ],
};

export const paramTarifMockData = {
    pages: [
        {
            name: "Paramétrage de garanties",
            description:
                "Définir les garanties, leurs primes et capitaux d'indemnisation selon les caractéristiques des engins.",
            url: "/garanties",
            icon: "bx-shield-quarter",
        },
        {
            name: "Paramétrage de réductions",
            description:
                "Configurer les taux de réduction et les garanties concernées.",
            url: "/reductions",
            icon: "bx-down-arrow-circle",
        },
        {
            name: "Paramétrage de conversions d’énergie",
            description:
                "Gérer les conversions d’énergie pour le calcul de la Responsabilité Civile.",
            url: "/parametres/conversion",
            icon: "bx-gas-pump",
        },
        {
            name: "Paramétrage de catégories d’engins",
            description:
                "Définir les catégories d’engins pris en charge par le POOL TPVM-VT GIE.",
            url: "/categories",
            icon: "bx-category",
        },
        {
            name: "Paramétrage de fractionnements",
            description:
                "Configurer les différents modes de fractionnement applicables sur les contrats.",
            url: "/parametres/fractionnements",
            icon: "bx-layer",
        },
        {
            name: "Paramétrage des avenants",
            description:
                "Définir les différents avenants disponibles et leurs codes associés.",
            url: "/parametres/avenants",
            icon: "bx-file",
        },
        {
            name: "Paramétrage des carrosseries",
            description:
                "Gérer les types de carrosseries selon les catégories d’engins.",
            url: "/parametres/carosseries",
            icon: "bx-car",
        },
        {
            name: "Paramétrage des usages",
            description:
                "Configurer les usages possibles pour les engins selon leur catégorie.",
            url: "/parametres/usages",
            icon: "bx-traffic-cone",
        },
        {
            name: "Paramétrage des marques",
            description:
                "Définir les marques d’engins par catégorie pour une meilleure classification.",
            url: "/parametres/marques",
            icon: "bx-purchase-tag",
        },
        {
            name: "Paramétrage des accessoires",
            description:
                "Configurer les accessoires et les frais associés aux engins.",
            url: "/parametres/accessoires",
            icon: "bx-cog",
        },
        {
            name: "Paramétrage des taux de commissions",
            description:
                "Définir les taux de commissions selon les catégories et types d’apporteurs.",
            url: "/parametres/taux-commissions",
            icon: "bx-percent",
        },
        {
            name: "Paramétrage du numéro de police",
            description:
                "Configurer le format et les règles du numéro de police.",
            url: "/autre-parametres/numero-police",
            icon: "bx-hash",
        },
        {
            name: "Paramétrage des taxes",
            description:
                "Définir les taxes applicables selon les garanties concernées.",
            url: "/parametres/taxes",
            icon: "bx-calculator",
        },
    ],
};

export const paramSinistreMockData = {
    pages: [
        {
            name: "Paramétrage du numéro de sinistre",
            description: "Configurer le format et les règles du numéro de sinistre.",
            url: "/autre-parametres/numero-sinistre",
            icon: "bx-hash",
        },
        {
            name: "Paramétrage des causes de sinistre",
            description: "Définir et gérer les différentes causes de sinistre.",
            url: "/autre-parametres/cause-sinistres",
            icon: "bx-error",
        },
        {
            name: "Paramétrage des préjudices",
            description: "Gérer les types de préjudices liés aux sinistres.",
            url: "/autre-parametres/prejudices",
            icon: "bx-first-aid",
        },
        {
            name: "Paramétrage des natures d'actes",
            description:
                "Définir les différentes natures d'actes utilisés dans le traitement des sinistres.",
            url: "/autre-parametres/nature-acte",
            icon: "bx-file",
        },
        {
            name: "Paramétrage des experts",
            description:
                "Gérer les experts agréés intervenant dans le processus de gestion des sinistres.",
            url: "/autre-parametres/experts",
            icon: "bx-user-check",
        },
        {
            name: "Paramétrage des entités de constat",
            description:
                "Définir les organismes ou structures habilités à effectuer les constats d’accident.",
            url: "/autre-parametres/entites-constat",
            icon: "bx-building-house",
        },
        {
            name: "Paramétrage de la somme minimale des sinistres à payer",
            description:
                "Configurer la somme minimale en dessous de laquelle un sinistre ne peut être réglé.",
            url: "/autre-parametres/somme-minimale-a-payer",
            icon: "bx-money-withdraw",
        },
        {
            name: "Paramétrage du barème d’évaluation",
            description:
                "Définir les barèmes d’évaluation pour estimer les dommages lors de la déclaration d’un sinistre.",
            url: "/autre-parametres/bareme-evaluation",
            icon: "bx-calculator",
        },
        {
            name: "Paramétrage des types de pièces",
            description:
                "Gérer les types de pièces justificatives nécessaires à la constitution d’un dossier sinistre.",
            url: "/autre-parametres/type-pieces",
            icon: "bx-id-card",
        },
        {
            name: "Paramétrage du SMIG",
            description: "Définir la valeur du SMIG utilisée dans le calcul des indemnisations.",
            url: "/parametres/smig",
            icon: "bx-line-chart",
        },
        {
            name: "Paramétrage de la valeur point IP",
            description:
                "Configurer la valeur du point IP servant de base au calcul des indemnisations.",
            url: "/parametres/ajouter-valeur-point-ip",
            icon: "bx-target-lock",
        },
        {
            name: "Paramétrage de l’âge limite de paiement de rente",
            description:
                "Définir la limite d’âge pour le paiement des rentes dans les dossiers sinistres.",
            url: "/parametres/age-limite-paiement-rente",
            icon: "bx-time",
        },
        {
            name: "Paramétrage des Pretium Doloris",
            description:
                "Configurer les barèmes de Pretium Doloris pour l’évaluation des dommages corporels.",
            url: "/parametres/pretium-doloris",
            icon: "bx-heart",
        },
        {
            name: "Paramétrage des établissements",
            description: "Définir et gérer les établissements.",
            url: "/autre-parametres/etablisements",
            icon: "bx-buildings",
        },
        {
            name: "Paramétrage des types d’établissement",
            description: "Gérer les types d’établissement utilisés en sinistre.",
            url: "/autre-parametres/type-etablissements",
            icon: "bx-building-house",
        },
    ],
};

export const paramGenerauxMockData = {
    pages: [
        {
            name: "Paramétrage de profession",
            description: "Définir et gérer les différentes professions utilisées dans le système.",
            url: "/autre-parametres/professions",
            icon: "bx-briefcase",
        },
        {
            name: "Paramétrage des villes",
            description: "Configurer la liste des villes disponibles pour les adresses et contrats.",
            url: "/autre-parametres/villes",
            icon: "bx-map",
        },
        {
            name: "Paramétrage de banques",
            description: "Gérer les banques et institutions financières partenaires.",
            url: "/autre-parametres/banques",
            icon: "bx-bank",
        },
        {
            name: "Paramétrage des types de profils",
            description: "Définir les différents types de profils utilisateurs du système.",
            url: "/autre-parametres/type-profils",
            icon: "bx-user-circle",
        },
        {
            name: "Paramétrage des exercices",
            description: "Configurer les périodes d’exercice comptable pour la gestion annuelle.",
            url: "/autre-parametres/exercices",
            icon: "bx-calendar",
        },
        {
            name: "Paramétrage des produits relatifs aux attestations",
            description: "Configurer les différents produits associés aux attestations d’assurance.",
            url: "/autre-parametres/produits-attestation",
            icon: "bx-package",
        },
        {
            name: "Paramétrage de lieux",
            description: "Gérer les régions, villes et quartiers utilisés dans le système.",
            url: "/autre-parametres/lieux",
            icon: "bx-map-pin",
        },
        {
            name: "Paramétrage de la clé de répartition",
            description: "Définir les règles de répartition des cessions entre les membres du pool.",
            url: "/autre-parametres/cle-de-repartition",
            icon: "bx-sitemap",
        },
        {
            name: "Autres Paramètres",
            description: "Gérer les paramètres généraux additionnels du système.",
            url: "/autre-parametres/autre-parametre",
            icon: "bx-cog",
        },
    ],
};
